

export interface IRefModalFormulaAssistant {
  openModal: (idIndicator: number, defaultFormula?: string, callBackFormula?: (formula: string, textFormula: string) => void, idField?: number) => void;
}

export interface IModalFormulaAssistant{
  methodRequestValuesFormula?: string;
  showFieldFilter?: boolean;
  showOnlyDescription?: boolean;
}

export enum IFilterMeta{
  ONLY_METAS = "OM",
  ONLY_FIELDS = "OF",
  ALL = "AL",
}
